import cx from 'classnames'
import React from 'react'

import Link from '@cinch/oxd-components/link/src'
import GlobalContext from '@cinch/oxd-utils/context/src'

import * as mainStyles from './navigation.module.css'

import * as partnersStyles from './partners-navigation.module.css'

const Navigation: React.FC<{ styles?: any; dimmable?: boolean; menuType?: any }> = ({
  styles,
  dimmable,
  menuType = 'main',
}) => {
  if (!styles) {
    styles = menuType === 'main' ? mainStyles : partnersStyles
  }

  return (
    <GlobalContext.Consumer>
      {({ navigation }) => {
        const mainLinks = [
          { id: 'buy', label: navigation.buy, to: '/find-vehicle' },
          { id: 'help', label: navigation.help, to: '/lifestyle/budget' },
          { id: 'sell', label: navigation.sell, to: '/sell' },
          { id: 'jargon', label: navigation.jargon, to: '/jargon' },
          { id: 'guides', label: navigation.guides, to: '/guides' },
        ]
        const partnersLinks = [
          { id: 'overview', label: navigation.partners.overview, to: '/partners/dashboard' },
          { id: 'dealerships', label: navigation.partners.dealerships, to: '/partners/dealerships' },
        ]

        const links = menuType === 'partners' ? partnersLinks : mainLinks

        return (
          <>
            <nav className={cx(styles.nav, { [styles.dimOvercast]: dimmable })}>
              {links.map(({ label, to, id }) => (
                <Link key={id} className={styles.link} activeClassName={styles.activeLink} to={to} children={label} />
              ))}
              {menuType !== 'partners' && <div id="LP_DIV_1565102226690" />}
            </nav>
            <div ub-in-page="5d4a93ba4f72d9582865dfe6" />
          </>
        )
      }}
    </GlobalContext.Consumer>
  )
}

export default Navigation
